import axios from 'axios'
import {
  Message
} from 'element-ui'
import router from '@/router/index'
import store from '@/store/';

// https://api.wine.nectarspirit.com https://dev.api.wine.xuanze00.top
const request = axios.create({
  // 本地服务 http://192.168.31.239:9001/api
  // 正式服务 https://api.wine.nectarspirit.com/api
  baseURL: 'https://api.wine.nectarspirit.com/api', // 注意！！ 这里是全局统一加上了 '/api' 前缀，也就是说所有接口都会加上'/api'前缀在，页面里面写接口的时候就不要加 '/api'了，否则会出现2个'/api'，类似 '/api/api/user'这样的报错，切记！！！
  timeout: 10000,
  withCredentials: true
})

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
  console.log(config, 'config', store)
  config.headers['Content-Type'] = 'application/json;charset=utf-8'
  if (config.url !== '/user/login') {
    config.headers['Token'] = store.state.user.token; // 设置请求头
  }
  return config
}, error => {
  return Promise.reject(error)
})

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
  response => {
    let res = response.data
    // // 如果是返回的文件
    // if (response.config.responseType === 'blob') {
    //   return res
    // }
    // // 兼容服务端返回的字符串数据
    // if (typeof res === 'string') {
    //   res = res ? JSON.parse(res) : res
    // }
    console.log(res, 'res response', response)
    if (response.headers.token) {
      localStorage.setItem('token', response.headers.token)
      store.state.user.token = response.headers.token
      console.log(store.state.user.token, 'store.state.user.token')
    }

    if (res.code !== 200) {
      if (res.code === 401) {
        // 登录失效
        localStorage.removeItem('isLogin')
        localStorage.removeItem('userInfo')
        localStorage.removeItem('token')
        store.state.user.token = ''
        store.state.user.isLogin = ''
        store.state.user.userInfo = {}
        // Message.warning('登录过期，请重新登录')
        setTimeout(() => {
          router.push({
            path: '/login'
          })
        }, 500)
        console.log(res, '401')
        return Promise.reject('登录过期，请重新登录')
      } else {
        return Promise.reject(res.msg.indexOf('参数错误') !== -1 ? res.data : res.msg)
      }
    } else {
      console.log(res, 'request')
      return res
    }
  },
  error => {
    // Message.error('网络错误，请重新加载')
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

export default request



// WEBPACK FOOTER //
// ./src/api/axios.js